module.exports = __webpack_public_path__ + "static/media/__online-shop.0ca32e97.svg";